import {
  Edit,
  SimpleForm,
  TextInput,
  BooleanInput,
  PasswordInput,
  SelectInput,
} from 'react-admin';
import Typography from '@material-ui/core/Typography';
import { CustomToolbar } from '../../components/CustomToolBar';
import { EditWithToolbarStyle } from '../../style';
import * as React from 'react';
import { useState } from 'react';

/**
 * UsersEdit component for editing existing users
 * Similar to DestinationEdit, but uses custom API endpoints
 */
export const UsersEdit = (props) => {
  const classes = EditWithToolbarStyle();
  const [changePassword, setChangePassword] = useState(false);

  // Transform data before submitting to API - simplified to match UsersCreate.js
  const transform = (data) => {
    // USE THE FORM DATA VALUE instead of React state
    // This ensures we use the latest value at submission time
    const shouldUpdatePassword = data._changePassword;

    const result = {
      ...data,
      roles: data.role ? [data.role] : []
    };

    // Only include password if the form toggle is ON and password exists
    if (!shouldUpdatePassword || !data.password) {
      delete result.password;
    }
    return result;
  };

  return (
    <div className={classes.card}>
      <a className={classes.breadcrumbLink} href="#/users">
        {'< Users'}
      </a>{' '}
      <Edit
        mutationMode="pessimistic"
        transform={transform}
        title="Edit User"
        {...props}
        actions={false}
        undoable={false}>
        <SimpleForm toolbar={<CustomToolbar isEdit={true} {...props} />}>
          <Typography variant="h6">Edit User</Typography>
          <TextInput className={classes.textField} helperText={false} source="email" disabled />
          <TextInput className={classes.textField} helperText={false} source="name" />

          {/* Password update section with toggle */}
          <BooleanInput
            className={classes.textField}
            label="Update Password"
            source="_changePassword"
            onChange={(e) => {
              setChangePassword(e);
            }}
            defaultValue={false}
            helperText={false}
          />
          <div style={{ display: changePassword ? 'block' : 'none' }}>
            <PasswordInput
              className={classes.textField}
              helperText={false}
              source="password"
              label="New Password"
              fullWidth
              autoComplete="new-password"
              validate={(value) => {
                if (changePassword && (!value || value.trim() === '')) {
                  return 'Password is required when updating password';
                }
                return undefined;
              }}
            />
          </div>

          <SelectInput
            className={classes.textField}
            source="role"
            choices={[
              { id: 'dh-admin', name: 'DH Admin' },
              { id: 'dh-user', name: 'DH User' },
              { id: 'brs-user', name: 'BRS User' },
              { id: 'ar-user', name: 'AR User' },
              { id: 'aviary-admin', name: 'Aviary Admin' }
            ]}
          />
        </SimpleForm>
      </Edit>
    </div>
  );
};
